<template>
  <div class="rightTop">
    <div class="title" :class="menuItem.productTurnoverRank ? 'setCursor' : ''" @click="showModel">产品供应</div>
    <div class="list">
      <div class="item">
        <img class="icon" src='@/assets/images/home/icon-qysl.png' />
        <div class="text">售卖产品总数量</div>
        <div class="num">{{ summary.salesNum || 0 | formatNumber }}<span>件</span></div>
      </div>
      <div class="item">
        <img class="icon" src='@/assets/images/home/icon-qysl.png' />
        <div class="text">产品商品总数量</div>
        <div class="num">{{ summary.productNum || 0 | formatNumber }}<span>个</span></div>
      </div>
    </div>
    <div class="content">
      <div class="canvas">
        <div id="rightTop-canvas"></div>
        <div class="text">交易额</div>
      </div>
      <div class="right">
        <div class="title">
          <div class="text1">统计排名</div>
          <div class="text2">销量</div>
        </div>
        <div class="right-list">
          <div v-for="(item, index) of topPriceSummary" :key='index' class="item">
            <div class="icon" :style="{ 'background': colors[index] }"></div>
            <div class="contenttext">
              <div class="name" :title="item.productName">{{ item.productName | isEmptyVal }}</div>
              <div class="num">
                <span>{{ item.salesNum || 0 | formatNumber }}</span>
                <span class="unit">件</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
import apiPath from '@config/api.json'
const { mapState, mapMutations } = require('vuex')
export default {
  components: {},

  data () {
    return {
      menuItem: {
        productTurnoverRank: false // 产品交易额/销量TOP排名
      },
      summary: {},
      topPriceSummary: [],
      tableData: [],
      tableHeader: [
        {
          prop: 'a',
          label: 'TOP 排名'
        },
        {
          prop: 'b',
          label: '商品名称'
        },
        {
          prop: 'c',
          label: '交易额（万)'
        },
        {
          prop: 'd',
          label: '销量（件)'
        }
      ],
      topQuantitySummary: [],
      colors: ['#B7BA52', '#4EC37C', '#50CFFF', '#0171FC', '#6543D6'],
      text: '',
      myChart: null, // 图表对象
      initObj: null // 用于定时器处理
    }
  },

  computed: {
    ...mapState({
      homeTime: (state) => {
        return state.home.homeTime
      }
    })
  },

  watch: {
    homeTime: function (n) {
      this.init()
    }
  },

  created () {
    // this.setLanguageMsg(this.lan)
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.productTurnoverRank = common.isShowItem('productTurnoverRank', setListMenu)
    }
  },

  mounted () {
    this.myChart = this.$echarts.init(document.getElementById('rightTop-canvas'))
    this.init()
    this.initObj = setInterval(() => {
      this.init()
    }, 60000)
  },

  methods: {
    ...mapMutations(['setModelInfo']),
    init () {
      this.$ajax({
        method: 'get',
        url: apiPath.bigData.home.rightTop.getProductSales
      }).then(res => {
        if (res && res.data) {
          let dataInfo = res.data || []
          this.topPriceSummary = dataInfo // 交易额
          // this.topQuantitySummary = dataInfo.topQuantitySummary || [] // 排名
        }
        this.initCharts()
        this.loadStatistic()
      })
    },
    // 统计
    loadStatistic () {
      this.$ajax({
        method: 'post',
        url: apiPath.bigData.home.listProductsStatistic,
        data: {
          pageNum: 1,
          pageSize: 10
        }
      }).then(res => {
        if (res) {
          this.summary = res.data || {}
        }
      })
    },
    initCharts () {
      this.myChart && this.myChart.clear()
      let data = []
      for (let item of this.topPriceSummary) {
        data.push({
          name: item.productName || '',
          value: item.transaction || 0
        })
      }
      // let names = this.topQuantitySummary.map(item => {return item.productsName || '中国石化'})
      // let nums = this.topQuantitySummary.map(item => {return item.productQuantity || '中国石化'})
      var option
      option = {
        tooltip: {
          trigger: 'item'
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            center: ['51%', '50%'],
            radius: ['40%', '60%'],
            // radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            // label: {
            //   show: true,
            //   position: 'center'
            // },
            itemStyle: {
              normal: {
                color: function (parmas) {
                  let colorList = ['#66FFFF', '#9732FC', '#F1C233', '#4EC37C', '#0171FC', '#2890EC', '#73C0DE', '#EE6666', '#5470C6', '#91CC75', '#FAC858', '#2890EC']
                  return colorList[parmas.dataIndex]
                }
              }
            },
            dataZoom: {
              type: 'inside'
            },
            tooltip: {
              trigger: 'item'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold',
                color: '#fff'
              }
            },
            labelLine: {
              length: 5,
              length2: 5
            },
            label: {
              normal: {
                // formatter: '{b}\n'
                formatter: function (data) {
                  let text = data.name
                  return text.length > 3 ? `${text.slice(0, 3) + '...'} ` : `${text}`
                }
              }
            },
            data: data
          }
        ]
      }
      option && this.myChart.setOption(option)
    },
    showModel () {
      if (!this.menuItem.productTurnoverRank) return
      let that = this
      this.setModelInfo({
        modelUrl: 'listProductsStatistic',
        method: 'post',
        title: '产品交易额/销量TOP排名',
        headList: [
          {
            name: '售卖商品总数',
            value: that.summary.salesNum || '0',
            unit: '（件）'
          }, {
            name: '商品总数量',
            value: that.summary.productNum || '0',
            unit: '（件）'
          }
        ],
        model: true
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.initObj)
  }
}
</script>

<style lang="scss" scoped>
.rightTop {
  width: 454px;
  height: 291px;
  background: url('~@/assets/images/home/title-bg.png') no-repeat 0 0;
  background-size: 100% 100%;

  .title {
    height: 18px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #00FAFF;
    width: 100%;
    line-height: 18px;
    margin-top: 16px;
    text-align: center;
  }

  .list {
    display: flex;
    justify-content: space-between;
    margin: 16px 30px 0 30px;

    .item {
      display: flex;
      align-items: center;

      .icon {
        width: 34px;
        height: 34px;
      }

      .text {
        font-size: 10px;
        margin-right: 10px;
      }

      .num {
        font-size: 14px;

        // color:#30FDFF;
        span {
          font-size: 10px;
        }
      }
    }
  }

  .content {
    display: flex;
    margin: 16px 18px 0 18px;
    width: 420px;
    height: 176px;

    .canvas {
      position: relative;
      width: 220px;
      height: 176px;

      .text {
        position: absolute;
        top: 50%;
        left: 50%;
        text-align: center;
        transform: translate(-50%, -50%);
        font-size: 20px;
        font-weight: bold;
        z-index: 9;
      }
    }

    .right {
      margin-left: 10px;

      .title {
        display: flex;
        margin-top: 0;
        font-size: 11px;
        color: #fff;

        .text1 {
          margin-left: 38px;
        }

        .text2 {
          margin-left: 69px;
        }
      }

      .right-list {
        margin-top: 10px;
        .item {
          display: flex;
          height: 20px;
          line-height: 20px;
          align-items: center;
          background: rgba(63, 154, 255, 0.2);
          margin-left: 6px;
          margin-right: 0;
          margin-bottom: 12px;

          .icon {
            width: 8px;
            height: 8px;
            background: #B7BA52;
            margin-left: 7px;
            border-radius: 50%;
          }

          .contenttext {
            margin-left: 17px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex: 1;

            .name {
              max-width: 90px;
              overflow: hidden;
              line-height: 24px;
              height: 24px;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .num {
              // width: 36px;
              text-align: right;
              white-space: nowrap;

              .unit {
                font-size: 10px;
              }
            }
          }
        }
      }
    }

    #rightTop-canvas {
      width: 220px;
      height: 176px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/home/compontents/rightTop.vue